import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {GetBankAccountListAction} from './get-bank-account-list.action';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {ApiAccessToken, ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {WebhookLogModel} from '../../data/model/WebhookLogModel/webhook_log.model';
import {BankAccountModel} from '../../data/model/BankAccountModel/bank-account.model';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {debounceTime} from 'rxjs/operators';
import {ErrorConstants} from '../../shared/constants/error-constants';
import {AppConstants} from '../../shared/constants/app-constants';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import {PermissionConstants} from '../../shared/constants/permission-constants';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {SubscriptionComponent} from '../../subscriptionModule/subscription/subscription.component';
import {Subject, Subscription} from 'rxjs';
import {Highlight} from '../../shared/highlights/highlight';
import {ApiTokenComponent} from '../../dialogs/api-token/api-token.component';
import {ChangeRequestDialogComponent} from '../../dialogs/change-request-dialog/change-request-dialog.components';
import {ariaSort, SortDirection} from '../../ui/table/payarc-sort-icon.component';
import {PagerPage} from '../../ui/pager/payarc-pager.component';

@Component({
    selector: 'app-bank-account-list',
    templateUrl: './bank-account-list.component.html',
    styleUrls: ['./bank-account-list.component.css'],
    standalone: false
})
export class BankAccountListComponent extends GetBankAccountListAction implements OnInit {
  dataManager: DataManagerService;
  runActionDialog: Subscription;
  bankAccountList: ApiResponseModel<BankAccountModel>;
  _service_name = '/merchant_bank_accounts';
  @Input() AccountData: any;
  constructor(
    route: ActivatedRoute,
    private dialog: MatDialog,
    router: Router,
    dataManager: DataManagerService,
    snackBar: MatSnackBar,
    @Inject('LOCALSTORAGE') private localStorage: any, private datePipe: DatePipe,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super();
    this.dataManager = dataManager;
    this.snackBar = snackBar;
    this.searchHits = new Subject<void>();
    this.alertDialog = dialog;
    this.errorMsg = null;
    this.emptyListMsg = ErrorConstants.bankAccountsErrorMsg[0];
    this.route = route;
    this.router = router;
    this.bankAccountList = new ApiResponseModel<BankAccountModel>();
    this.getListUrl = AppConstants.BASE_URL + this._service_name;
  }
    ngOnInit(): void {
      if (isPlatformBrowser(this.platformId)) {
        if (
          !this.localStorage.getItem(this.filter_storage_key) &&
          !this.localStorage.getItem(this.count_storage_key)
        ) {
          this.setUrl();
        }
      }
  }
  highlight(value) {
    return Highlight.highlight(value, this.searchText);
  }
  limitChange() {
    this.setUrl(1);
  }

  /** Overrides the base no-arg `setUrl()` with an explicit page, so the pager can request
   * any page without the base implementation's implicit reset to page 1. */
  setUrl(page = 1): string {
    let url = this.getListUrl + '?limit=' + (isNaN(this.limit) ? 0 : this.limit) + '&page=' + page;
    if (!this.isNullOrUndefined(this.orderBy)) {
      url += '&orderBy=' + this.orderBy + '&sortedBy=' + this.sortBy;
    }
    this.getList(url);
    return url;
  }

  get currentPage(): number {
    return this.metadata?.['current_page'] || 1;
  }

  get totalPages(): number {
    const total = this.metadata?.['total'] || 0;
    return this.limit > 0 ? Math.max(1, Math.ceil(total / this.limit)) : 1;
  }

  get pagerRangeLabel(): string {
    if (!this.metadata?.['total']) {
      return '';
    }
    const start = 1 + (this.currentPage - 1) * this.limit;
    const end = this.currentPage === 1 ? this.metadata['count'] : start + this.metadata['count'] - 1;
    return `Showing ${start}–${end} of ${this.metadata['total']}`;
  }

  get pagerPages(): PagerPage[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) {
      return Array.from({length: total}, (_, i) => i + 1);
    }
    const pages = new Set<number>([1, total, current, current - 1, current + 1]);
    const sorted = [...pages].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
    const out: PagerPage[] = [];
    let prev = 0;
    for (const p of sorted) {
      if (prev && p - prev > 1) {
        out.push('...');
      }
      out.push(p);
      prev = p;
    }
    return out;
  }

  pagerPrev() {
    this.setUrl(Math.max(1, this.currentPage - 1));
  }

  pagerNext() {
    this.setUrl(Math.min(this.totalPages, this.currentPage + 1));
  }

  pagerSelect(page: number) {
    this.setUrl(page);
  }

  sortDirection(key: string): SortDirection {
    if (this.orderBy !== key) { return null; }
    return this.sortBy === 'asc' ? 'asc' : 'desc';
  }

  ariaSort = ariaSort;
  protected getListErr(err) {
    this.errorMsg = this.networkErrorHandler(err.error, ErrorConstants.bankAccountsErrorMsg) || err.error?.message || 'Something went wrong.';
  }

  protected getListRes(bankAccountListResponse: ApiResponseModel<BankAccountModel>) {
    this.bankAccountList = bankAccountListResponse;
    this.metadata = bankAccountListResponse.meta.pagination;
    if (this.bankAccountList.data.length === 0) {
      this.errorMsg = ErrorConstants.bankAccountsErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }
  paginate(paginateExtension) {
    this.getList(paginateExtension);
  }
  openHistory() {
    this.router.navigateByUrl('/merchant/branding/change-request-history');
  }

  changeBankAccount() {
    console.log('Account Data', this.AccountData);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'pa-shell-dialog';
    dialogConfig.width = '480px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      legal_name: this.AccountData.account_name,
      ein: this.AccountData.tax_id,
      account_id: this.AccountData.id
    };
    this.runActionDialog = this.alertDialog.open(ChangeRequestDialogComponent, dialogConfig)
      .afterClosed().subscribe(
        res => {
          if (res === 'run') {
            this.getList(this.setUrl());
          }
        }
      );
  }
}
